module.exports = __webpack_public_path__ + "img/invigorate-multiple-cold.5e227b57.png";